import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

const VARIANTS = {
  itemTitle: {
    fontSize: gr.font.size.lg,
    fontWeight: gr.font.weight.semibold,
    color: gr.color.ink,
    lineHeight: 1.35,
  },
  body: {
    fontSize: gr.font.size.md,
    fontWeight: gr.font.weight.regular,
    color: gr.color.ink,
    lineHeight: gr.font.lineHeight.normal,
  },
  secondary: {
    fontSize: gr.font.size.sm,
    fontWeight: gr.font.weight.regular,
    color: gr.color.ink2,
    lineHeight: gr.font.lineHeight.normal,
  },
  caption: {
    fontSize: gr.font.size.xs,
    fontWeight: gr.font.weight.regular,
    color: gr.color.muted,
    lineHeight: 1.4,
  },
  number: {
    fontSize: gr.font.size.h2,
    fontWeight: gr.font.weight.semibold,
    color: gr.color.ink,
    lineHeight: 1.15,
    fontVariantNumeric: "tabular-nums",
  },
};

// Text styles of the GymRite type scale. `as` sets the element (p by default, span for inline).
export default function GrText({
  variant = "body",
  as = "p",
  children,
  sx,
  ...rest
}) {
  return (
    <Box
      component={as}
      sx={{ m: 0, fontFamily: gr.font.family, ...VARIANTS[variant], ...sx }}
      {...rest}
    >
      {children}
    </Box>
  );
}

GrText.propTypes = {
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
  as: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object,
};
